import React, { useContext } from 'react';
import { useAtom } from 'jotai';
import Brand from '../../../layout/Brand/Brand';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import { companyPageMenues, customerPageMenues, dashboardPagesMenu, programMenues, marketingPageMenues, calendarPageMenues, financeReportPageMenues, webPageMenues, saloonPageMenues } from '../../../menu';
import ThemeContext from '../../../contexts/themeContext';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import { userAtom } from '../../../_atoms/user';
import { companyAtom } from '../../../_atoms/company';

const DefaultAside = () => {
	const [user] = useAtom(userAtom)
	const [company] = useAtom(companyAtom)
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);

	const isAdmin = company && company.admins && company.admins.length > 0 && company.admins.map(a => a._id).indexOf(user._id) > -1

	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				<Navigation menu={dashboardPagesMenu} id='aside-dashboard' />
				<NavigationLine />
				{isAdmin &&
					<>
						<Navigation menu={companyPageMenues} id='aside-company' />
						<NavigationLine />
					</>
				}
				{(isAdmin || user.canSee.indexOf("saloon") > -1) &&
					<>
						<Navigation menu={saloonPageMenues} id='aside-saloon' />
						<NavigationLine />
					</>
				}
				{(isAdmin || user.canSee.indexOf("marketing") > -1) &&
					<>
						<Navigation menu={marketingPageMenues} id='aside-marketing' />
						<NavigationLine />
					</>
				}
				{(isAdmin || user.canSee.indexOf("financeReport") > -1) &&
					<>
						<Navigation menu={financeReportPageMenues} id='aside-calendar' />
						<NavigationLine />
					</>
				}
				{(isAdmin || user.canSee.indexOf("customer") > -1) &&
					<>
						<Navigation menu={customerPageMenues} id='aside-customer' />
						<NavigationLine />
					</>
				}
				{(isAdmin || user.canSee.indexOf("program") > -1) &&
					<>
						<Navigation menu={programMenues} id='aside-program' />
						<NavigationLine />
					</>
				}
				{(isAdmin || user.canSee.indexOf("calendar") > -1) &&
					<>
						<Navigation menu={calendarPageMenues} id='aside-calendar' />
						<NavigationLine />
					</>
				}
				{(isAdmin || user.canSee.indexOf("web") > -1) &&
					<>
						<Navigation menu={webPageMenues} id='aside-web' />
						<NavigationLine />
					</>
				}
			</AsideBody>
			<AsideFoot>
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
